<script>
  import { createEventDispatcher } from "svelte";
  import { navigateTo } from "svelte-router-spa";
  import { Link, TextField, SelectField } from "@saztrek/firefly";
  import { BRANDS } from "../../../../gql";

  import CRUDPage from "../../../components/CRUDPage.svelte";
  import { selectOptions } from "../../../components/defaultObjects";

  const dispatch = createEventDispatcher();
  const columns = [
    {
      field: "code",
      name: "Code",
      renderComponent: Link,
      resolveProps: (data) => {
        return {
          href: `brands/edit/${data.code}`
        };
      }
    },
    {
      field: "name",
      name: "Name",
      dataType: "string"
    },
    {
      field: "manufacturer",
      name: "Manufacturer",
      renderComponent: Link,
      resolveProps: (value) => {
        return {
          href: `manufacturers/edit/${value}`
        };
      }
    }
  ];

  const tableActions = [
    {
      icon: "pencil",
      title: "Edit",
      action: (data) => {
        navigateTo(`brands/edit/${data.code}`);
      }
    },
    {
      icon: "trash",
      title: "Inactivate",
      action: (data) => {
        dispatch("inactivateBrand", { code: data.code });
      }
    }
  ];

  const findObjectInput = {
    findBrandInput: {
      code: undefined,
      name: undefined,
      manufacturerCode: undefined,
      version: undefined
    }
  };

  let code;
  let name;
  let manufacturerCode;
  let isActiveList;

  const resetSearch = () => {
    code = "";
    name = "";
    manufacturerCode = "";
    return {
      findBrandInput: {
        code: undefined,
        name: undefined,
        manufacturerCode: undefined
      }
    };
  };

  const updateSearch = () => {
    return {
      findBrandInput: {
        code: code !== "" ? code : undefined,
        name: name !== "" ? name : undefined,
        manufacturerCode: manufacturerCode !== "" ? manufacturerCode : undefined
      }
    };
  };

  const goToAddAccount = () => {
    navigateTo("brands/new");
  };

  const processResponse = (response) => {
    const processEdges = (edges) => {
      return edges.map((edge) => {
        const { node } = edge;
        return {
          code: node.code,
          name: node.name,
          manufacturer: `${node.manufacturer.code} - ${node.manufacturer.name}`
        };
      });
    };

    const { data } = response;
    const { brands } = data;
    const { edges } = brands;

    return {
      items: processEdges(edges),
      currentData: brands
    };
  };
</script>

<div class="w-full px-10">
  <CRUDPage
    gqlQuery={BRANDS}
    {columns}
    {tableActions}
    {processResponse}
    {findObjectInput}
    {resetSearch}
    {updateSearch}
    goToAdd={goToAddAccount}>
    <div slot="searchform" class="w-full grid grid-cols-1 md:grid-cols-4 gap-2">
      <TextField type="search" placeholder="Code" bind:textValue={code} />
      <TextField type="search" placeholder="Name" bind:textValue={name} />
      <TextField
        type="search"
        placeholder="Manufacturer"
        bind:textValue={manufacturerCode} />
      <SelectField options={selectOptions} bind:value={isActiveList} />
    </div>
  </CRUDPage>
</div>
